import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, FormControlLabel, FormLabel, Radio, RadioGroup, } from "@mui/material";
import { useCallback, useMemo, useState } from "react";
import moment, { Moment } from "moment";
import PaperDraggable from "../../../../../../../../components/PaperDraggable";
import DateComIntervalo from "../../../../../../../../components/DateComIntervalo";

export default function TitPagarAberto({
  open,
  defaultValue,
  onClose,
  onSubmitFiltros,
}: TitPagarAbertoProps) {

  const [titPagarFiltros, setTitPagarFiltros] = useState<TTitPagarFiltros>({
    considera_titulos: defaultValue.considera_titulos ?? "Sim",
    periodo_emissao_inicio: defaultValue.periodo_emissao_inicio ? moment(defaultValue.periodo_emissao_inicio) : null,
    periodo_emissao_fim: defaultValue.periodo_emissao_fim ? moment(defaultValue.periodo_emissao_fim) : null,
    periodo_vencimento_inicio: defaultValue.periodo_vencimento_inicio ? moment(defaultValue.periodo_vencimento_inicio) : null,
    periodo_vencimento_fim: defaultValue.periodo_vencimento_fim ? moment(defaultValue.periodo_vencimento_fim) : null
  });

  const handleChangePagarFiltros = (name: string, value: any) => {
    setTitPagarFiltros(prevState => ({ ...prevState, [name]: value }));
  }

  const handleSubmit = useCallback(() => {
    onSubmitFiltros({
      periodo_emissao_inicio: titPagarFiltros.periodo_emissao_inicio?.format('YYYY-MM-DD'),
      periodo_emissao_fim: titPagarFiltros.periodo_emissao_fim?.format('YYYY-MM-DD'),
      periodo_vencimento_inicio: titPagarFiltros.periodo_vencimento_inicio?.format('YYYY-MM-DD'),
      periodo_vencimento_fim: titPagarFiltros.periodo_vencimento_fim?.format('YYYY-MM-DD'),
      considera_titulos: titPagarFiltros.considera_titulos
    });
    onClose();
  }, [titPagarFiltros, onClose, onSubmitFiltros]);

  const opcoesRadio = useMemo(() => [
    { value: "Sim", label: "Considerar" },
    { value: "Não", label: "Nenhum" },
  ], [])

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth={'xs'}
      PaperComponent={PaperDraggable}
      aria-labelledby="draggable-dialog-title"
      fullWidth
    >
      <DialogTitle style={{ cursor: 'move' }} id="draggable-dialog-title">Títulos a pagar em aberto</DialogTitle>
      <DialogContent>
        <Box mt={1} display={'flex'} flexDirection={'column'} gap={2}>
          <FormControl>
            <FormLabel id="consideraTitulo">Considerar títulos?</FormLabel>
            <RadioGroup
              row
              aria-labelledby="consideraTitulo"
              value={titPagarFiltros.considera_titulos}
              onChange={(e) => handleChangePagarFiltros("considera_titulos", e.target.value)}
            >
              {
                opcoesRadio.map((opcao, index) => (
                  <FormControlLabel key={index} value={opcao.value} control={<Radio />} label={opcao.label} />
                ))
              }
            </RadioGroup>
          </FormControl>
          {
            titPagarFiltros.considera_titulos === "Sim" &&
            <>
              <DateComIntervalo
                data={{
                  inicial: (titPagarFiltros.periodo_emissao_inicio),
                  final: (titPagarFiltros.periodo_emissao_fim)
                }}
                onChangeData={(data) => {
                  handleChangePagarFiltros("periodo_emissao_inicio", data.inicial)
                  handleChangePagarFiltros("periodo_emissao_fim", data.final)
                }}
                datePickerView={['year', 'month', 'day']}
                formatString="DD/MM/YYYY"
                labelInput="Período de emissão"
                possuiBtnLimpar
              />
              <DateComIntervalo
                data={{
                  inicial: (titPagarFiltros.periodo_vencimento_inicio),
                  final: (titPagarFiltros.periodo_vencimento_fim)
                }}
                onChangeData={(data) => {
                  handleChangePagarFiltros("periodo_vencimento_inicio", data.inicial)
                  handleChangePagarFiltros("periodo_vencimento_fim", data.final)
                }}
                datePickerView={['year', 'month', 'day']}
                formatString="DD/MM/YYYY"
                labelInput="Período de vencimento"
                possuiBtnLimpar
              />
            </>
          }

        </Box>
      </DialogContent>
      <DialogActions>
        <Box display={'flex'} gap={2}>
          <Button variant="outlined" onClick={onClose}>
            Fechar
          </Button>
          <Button variant="contained" color="primary" onClick={handleSubmit}>
            Alterar
          </Button>
        </Box>
      </DialogActions>
    </Dialog>
  )
}

interface TitPagarAbertoProps {
  open: boolean
  defaultValue: {
    periodo_emissao_inicio: string | null;
    periodo_emissao_fim: string | null;
    periodo_vencimento_inicio: string | null;
    periodo_vencimento_fim: string | null;
    considera_titulos: "Sim" | "Não" | null
  }
  onClose: () => void
  onSubmitFiltros: (value: any) => void
}

type TTitPagarFiltros = {
  periodo_emissao_inicio: Moment | null
  periodo_emissao_fim: Moment | null
  periodo_vencimento_inicio: Moment | null
  periodo_vencimento_fim: Moment | null
  considera_titulos: "Sim" | "Não" | null
}
